<template>
  <div>
    <home-header></home-header>
    <div class="content page-width">
      <personal-center></personal-center>
      <h1>
        <div class="titles">通知公告</div>
      </h1>
      <div class="margin-top-30"></div>
      <news-list :arrs="arrs"></news-list>
      <div class="pagination">
        <a-pagination show-quick-jumper :default-current="1" :total="total" :current="pageNo" :pageSize="pageSize" @change="onChange" />
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import NewsList from './components/NewsList'
import PersonalCenter from '@/common/components/PersonalCenter'

export default {
  name: 'Notice',
  components: {
    HomeHeader,
    Foot,
    NewsList,
    PersonalCenter
  },
  data: function () {
    return {
      arrs: [],
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getDetailInfo()
    }else{
      this.common.toURL('/login')
    }
  },
  methods: {
    getDetailInfo() {
      this.axios
        .get(
          `/biz/home/notify/list?pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        )
        .then((res) => {
          if (res.success) {
            this.total = res.result.total
            this.arrs = res.result.records
          }
        })
    },
    handleGetDataSucc(res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.arrs = data.course
      }
    },
    table(index) {
      this.num = index
    },
    onChange(index) {
      this.pageNo = index
      this.getDetailInfo()
    }
  },
  mounted() {
    // this.getDetailInfo()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
h1 {
  font-size: 18px;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  .titles {
    position: relative;
    top: 10px;
  }
}
.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;

    .localtion {
      line-height: 30px;
      border-bottom: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.content-left {
  background: #f7f6f6;
}
.choose {
  width: 300px;
  margin: 0 auto;
  .btn {
    width: 90px;
    border: 1px solid $borderColor;
    margin-bottom: 20px;

  }
}

.choose li {
  float: left;
}

.active {
  background: $bgColor;
  color: #fff;
  border: 1px solid $bgColor;
}

.btn:focus, .btn.focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
<style lang="stylus">
.pagination {
  width: 100%;
  display: flex;
  background: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 30px;
}
/deep/ .ant-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: $bgColor!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/notice/Index.vue